export const dashboard = {
  menu: {
    overview: 'Vue d\'ensemble',
    profile: 'Mon profil',
    applications: 'Mes candidatures',
    cv: 'Mes CV',
    alerts: 'Alertes emploi',
    settings: 'Paramètres'
  },
  stats: {
    applications: 'Candidatures',
    profileViews: 'Vues du profil',
    responses: 'Réponses',
    savedJobs: 'Offres sauvegardées',
    thisMonth: 'Ce mois',
    thisWeek: 'Cette semaine',
    pending: 'En attente',
    total: 'Total'
  },
  recentApplications: {
    title: 'Candidatures récentes',
    viewAll: 'Voir tout'
  },
  status: {
    pending: 'En attente',
    inReview: 'En cours d\'examen',
    reviewed: 'Examinée',
    accepted: 'Acceptée',
    rejected: 'Refusée'
  },
  profile: {
    title: 'Mon profil',
    photo: 'Photo de profil',
    changePhoto: 'Changer la photo',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    location: 'Localisation',
    title: 'Titre professionnel',
    bio: 'Biographie',
    experience: 'Expérience',
    education: 'Formation',
    linkedin: 'LinkedIn',
    portfolio: 'Portfolio',
    save: 'Enregistrer les modifications'
  },
  applications: {
    title: 'Mes candidatures',
    total: 'candidatures',
    filter: {
      all: 'Toutes',
      pending: 'En attente',
      reviewed: 'Examinées',
      accepted: 'Acceptées',
      rejected: 'Refusées'
    },
    appliedOn: 'Postulé le',
    viewJob: 'Voir l\'offre',
    withdraw: 'Retirer la candidature'
  },
  cv: {
    title: 'Gestion des CV',
    uploadNew: 'Télécharger un nouveau CV',
    formats: 'PDF, DOC, DOCX (Max 5 MB)',
    myFiles: 'Mes fichiers',
    default: 'Par défaut',
    uploaded: 'Téléchargé le',
    download: 'Télécharger',
    setDefault: 'Définir par défaut',
    delete: 'Supprimer'
  },
  alerts: {
    title: 'Alertes emploi',
    create: 'Créer une alerte',
    newAlert: 'Nouvelle alerte',
    alertName: 'Nom de l\'alerte',
    keywords: 'Mots-clés',
    location: 'Localisation',
    frequency: 'Fréquence',
    daily: 'Quotidienne',
    weekly: 'Hebdomadaire',
    monthly: 'Mensuelle',
    save: 'Enregistrer',
    cancel: 'Annuler',
    active: 'Active',
    inactive: 'Inactive',
    created: 'Créée le',
    activate: 'Activer',
    deactivate: 'Désactiver',
    delete: 'Supprimer'
  },
  recommended: {
    title: 'Offres recommandées',
    viewAll: 'Voir toutes les offres',
    viewDetails: 'Voir les détails'
  },
  settings: {
    notifications: 'Notifications',
    emailNotifications: 'Notifications par email',
    emailNotificationsDesc: 'Recevoir des notifications par email',
    jobAlerts: 'Alertes emploi',
    jobAlertsDesc: 'Recevoir des alertes pour les nouvelles offres',
    applicationUpdates: 'Mises à jour des candidatures',
    applicationUpdatesDesc: 'Être notifié des changements de statut',
    newsletter: 'Newsletter',
    newsletterDesc: 'Recevoir notre newsletter mensuelle',
    privacy: 'Confidentialité',
    profileVisibility: 'Visibilité du profil',
    public: 'Public',
    private: 'Privé',
    recruitersOnly: 'Recruteurs uniquement',
    searchable: 'Profil consultable',
    searchableDesc: 'Permettre aux recruteurs de trouver votre profil',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    updatePassword: 'Mettre à jour le mot de passe',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    deleteAccount: 'Supprimer le compte',
    deleteAccountDesc: 'Cette action est irréversible. Toutes vos données seront supprimées.',
    deleteAccountButton: 'Supprimer mon compte'
  }
};

export const candidates = {
  hero: {
    title: 'Trouvez votre prochain emploi',
    subtitle: 'Des milliers d\'opportunités vous attendent. Créez votre profil et postulez en quelques clics.',
    findJob: 'Rechercher un emploi',
    createAccount: 'Créer un compte'
  },
  upload: {
    title: 'Déposez votre CV en quelques secondes',
    subtitle: 'Remplissez le formulaire ci-dessous et téléchargez votre CV pour commencer',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    location: 'Localisation',
    jobCategory: 'Catégorie d\'emploi',
    selectCategory: 'Sélectionnez une catégorie',
    experience: 'Expérience',
    selectExperience: 'Sélectionnez votre expérience',
    exp01: '0-1 an',
    exp13: '1-3 ans',
    exp35: '3-5 ans',
    exp510: '5-10 ans',
    exp10plus: '10+ ans',
    availability: 'Disponibilité',
    selectAvailability: 'Sélectionnez votre disponibilité',
    immediate: 'Immédiate',
    oneMonth: '1 mois',
    twoMonths: '2 mois',
    threeMonths: '3 mois',
    cvFile: 'Votre CV',
    clickToUpload: 'Cliquez pour télécharger',
    fileFormats: 'PDF, DOC ou DOCX (Max 5 MB)',
    submit: 'Envoyer ma candidature'
  },
  benefits: {
    title: 'Pourquoi choisir Travail Global ?',
    subtitle: 'Nous vous accompagnons à chaque étape de votre recherche d\'emploi',
    benefit1Title: 'Recherche personnalisée',
    benefit1Desc: 'Trouvez des offres qui correspondent parfaitement à votre profil et vos aspirations',
    benefit2Title: 'Alertes en temps réel',
    benefit2Desc: 'Soyez notifié instantanément des nouvelles opportunités qui vous correspondent',
    benefit3Title: 'Profil optimisé',
    benefit3Desc: 'Créez un profil attractif qui met en valeur vos compétences et votre expérience',
    benefit4Title: 'Suivi des candidatures',
    benefit4Desc: 'Gérez toutes vos candidatures depuis un tableau de bord unique et intuitif',
    benefit5Title: 'Opportunités internationales',
    benefit5Desc: 'Accédez à des offres d\'emploi partout dans le monde',
    benefit6Title: 'Accompagnement personnalisé',
    benefit6Desc: 'Bénéficiez de conseils d\'experts pour optimiser vos candidatures'
  },
  cta: {
    title: 'Prêt à démarrer votre carrière ?',
    subtitle: 'Rejoignez des milliers de candidats qui ont trouvé leur emploi idéal avec Travail Global',
    register: 'Créer mon compte',
    international: 'Recrutement international'
  }
};

export const auth = {
  login: {
    title: 'Connexion',
    subtitle: 'Connectez-vous à votre compte',
    candidate: 'Candidat',
    employer: 'Employeur',
    email: 'Email',
    password: 'Mot de passe',
    remember: 'Se souvenir de moi',
    forgot: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    noAccount: 'Pas encore de compte ?',
    register: 'S\'inscrire',
    welcomeTitle: 'Bienvenue sur Travail Global',
    welcomeSubtitle: 'Votre plateforme de recrutement de confiance'
  },
  register: {
    candidateTitle: 'Créer un compte candidat',
    candidateSubtitle: 'Commencez votre recherche d\'emploi dès aujourd\'hui',
    employerTitle: 'Créer un compte employeur',
    employerSubtitle: 'Trouvez les meilleurs talents pour votre entreprise',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    terms: 'J\'accepte les',
    termsLink: 'conditions d\'utilisation',
    submit: 'Créer mon compte',
    hasAccount: 'Vous avez déjà un compte ?',
    login: 'Se connecter',
    welcomeTitle: 'Rejoignez Travail Global',
    welcomeSubtitle: 'Des milliers d\'opportunités vous attendent',
    passwordMismatch: 'Les mots de passe ne correspondent pas'
  }
};